import React from 'react';
import styled from 'styled-components';
import toy from '../../assets/project/toy.png';

const ToyProject = () => {
  return (
    <Container>
      <div className='box-tag'>Mobile App</div>
      <div className='box-heading'>가능하다면 모바일까지.</div>
      <div className='box-detail'>
        <div className='box-desc-heading'>
          모바일 최적화된 웹뷰와 React Native 로 개발된 어플리케이션 서비스
          <div className='box-desc-list'>
            <div className='box-desc-list-item'>
              중고 시장 가격 비교
              <br />
              모바일 앱
            </div>
            <div className='box-desc-list-item'>
              뷰티 고객 관리
              <br />
              모바일 앱
            </div>
            <div className='box-desc-list-item'>
              점심 메뉴 투표 게임
              <br />
              모바일 웹뷰
            </div>
          </div>
        </div>
      </div>
      <div className='img-box'>
        <img
          src={toy}
          alt='enterprise search'
        />
      </div>
    </Container>
  );
};

const Container = styled.div`
  grid-column: span 2;
  align-self: stretch;

  .img-box {
    text-align: center;
    margin-top: 48px;

    img {
      width: 100%;
    }
  }

  background: linear-gradient(201deg, #ef278e 0%, #81347f 47%, #43407a 100%);
  border-radius: 25px;
  text-align: left;
  padding: 40px;

  .box-tag {
    margin-bottom: 40px;
    color: #fff;
    font-size: 19px;
    font-weight: 600;
  }

  .box-heading {
    font-size: 40px;
    font-weight: 700;
    color: #fff;
    margin-bottom: 24px;
  }

  .box-sub-heading {
    font-size: 64px;
    font-weight: 700;
    margin: 0;
    color: #fff;
    margin-bottom: 24px;
  }

  .box-detail {
    font-size: 19px;

    .box-desc-heading {
      color: #fff;
      margin-bottom: 8px;
    }

    .box-description {
      margin: 0;
    }

    .box-desc-list {
      display: flex;
      gap: 12px;
      flex-wrap: wrap;
      justify-content: space-evenly;
      margin-top: 48px;
      font-size: 36px;
      font-weight: 700;

      .box-desc-list-item {
        padding: 12px 18px;
        text-align: center;
      }
    }
  }

  @media only screen and (min-width: 769px) {
    grid-column: span 1;

    .box-detail {
      .box-desc-list {
        font-size: 48px;
      }
    }
  }

  @media only screen and (min-width: 1025px) {
    .box-detail {
      .box-desc-list {
        font-size: 56px;
      }
    }
  }
`;

export default ToyProject;
